'use strict';
const {
  TeamTypes,
  Accommodation,
  techniquesUsed,
  PayerType,
  ReceiverType,
  defaultInGuide,
  EventType,
  ProcedureBillingType} = require('../status');
const status = require('@common/status');

const PortesList = ['0'];
for (let i = 1; i < 15; i++) {
  for (const j of ['A', 'B', 'C']) {
    PortesList.push(String(i + j));
  }
}
const defaultPortesMap = {};
for (const p of PortesList) {
  defaultPortesMap[p] = {value: 0};
}

exports.default = exports;

exports.ProcedureBillingTypeArray = [
  {value: ProcedureBillingType.BILLABLE, text: 'Faturável'}, // Default
  {value: ProcedureBillingType.NOT_BILLABLE, text: 'Não faturável'},
  {value: ProcedureBillingType.ONLY_MAIN_ACTOR, text: 'Faturável somente para o ator principal'},
];

exports.validEmissionDateFields = {
  dtProcedure: 'dtProcedure',
  procedureStart: 'dtProcedure',
  anesthesiaStart: 'anesthesiaStart'
};

exports.KDEFAULT_EMISSION_DATE_FIELD = exports.validEmissionDateFields.dtProcedure;

exports.revenueConfigs = [
  {
    type: TeamTypes.KSURGEON,
    enable: false,
    percentRevenue: 1,
    grauPart: '00',
  },
  {
    type: TeamTypes.KPHONOAUDIOLOGIST,
    enable: false,
    percentRevenue: 1,
    grauPart: '00',
  },
  {
    type: TeamTypes.KASSISTANT_SURGEON,
    enable: false,
    percentRevenue: 0,
    grauPart: '',
    team: [
      {
        type: TeamTypes.KASSISTANT_SURGEON,
        enable: false,
        order: 0,
        percentRevenue: 0.6,
        grauPart: '01', // Vem com o default da ANS
      },
      {
        type: TeamTypes.KASSISTANT_SURGEON,
        enable: false,
        order: 1,
        percentRevenue: 0.4,
        grauPart: '02', // Vem com o default da ANS
      },
      {
        type: TeamTypes.KASSISTANT_SURGEON,
        enable: false,
        order: 2,
        percentRevenue: 0.3,
        grauPart: '03', // Vem com o default da ANS
      },
      {
        type: TeamTypes.KASSISTANT_SURGEON,
        enable: false,
        order: 3,
        percentRevenue: 0.3,
        grauPart: '04', // Vem com o default da ANS
      },
    ]
  },
  {
    type: TeamTypes.KSCRUB_NURSE,
    enable: false,
    percentRevenue: 1,
    grauPart: '05', // Vem com o default da ANS
  },
  {
    type: TeamTypes.KANESTHETIST,
    enable: true,
    percentRevenue: 1,
    grauPart: '06', // Vem com o default da ANS
  },
  {
    type: TeamTypes.KASSISTANT_ANESTHETIST,
    enable: false,
    percentRevenue: 0,
    grauPart: '',
    team: [
      {
        type: TeamTypes.KASSISTANT_ANESTHETIST,
        enable: true,
        order: 0,
        percentRevenue: 0.3,
        grauPart: '07', // Vem com o default da ANS
      },
      {
        type: TeamTypes.KASSISTANT_ANESTHETIST,
        enable: true,
        order: 1,
        percentRevenue: 0.3,
        grauPart: 'nao_fatura_pela_ans', // Com base nas regras da ANS, isso não é enviado para faturamento dos convênios.
      },
    ]
  },
  {
    type: TeamTypes.KRESIDENT_ANESTHETIST,
    enable: false,
    percentRevenue: 0,
    grauPart: 'nao_fatura_pela_ans', // Com base nas regras da ANS, isso não é enviado para faturamento dos convênios.
  },
  {
    type: TeamTypes.KRESIDENT_SURGEON,
    enable: false,
    percentRevenue: 0,
    grauPart: 'nao_fatura_pela_ans', // Com base nas regras da ANS, isso não é enviado para faturamento dos convênios.
  },
  {
    type: TeamTypes.KNURSE,
    enable: false,
    percentRevenue: 0,
    grauPart: 'nao_fatura_pela_ans', // Com base nas regras da ANS, isso não é enviado para faturamento dos convênios.
  },
];

exports.accommodationFactors = {
  [Accommodation.APARTMENT]: 2,
  [Accommodation.NURSERY]: 1,
  [Accommodation.OUTPATIENT]: 1,
  [Accommodation.ONE_DAY_CLINIC]: 1.5,
  [Accommodation.NONE]: 1,
};

exports.emergencyFactor = 1.3;
exports.emergencyFactorByEventType = {
  [EventType.Honorario]: 1.3,
  [EventType.Consulta]: 1.3,
  [EventType.SPSADT]: 1.3
};

exports.techniquesUsed = {
  [techniquesUsed.KConventional]: 1,
  [techniquesUsed.KVideo]: 1.5,
  [techniquesUsed.KRobotic]: 2,
};

exports.configsRange = {
  spsadt:{
    numberGuideRangePrestador:{
      useNumberGuideRangePrestador: false,
      rangeMin: 1,
      rangeMax: 20,
    },
    insuranceWalletRange:{
      useInsuranceWalletRange: false,
      rangeMin: 3,
      rangeMax: 20,
    },
    passwordRange:{
      usePasswordRange: false,
      rangeMin: 4,
      rangeMax: 20,
    }
  },
  consultation:{
    numberGuideRangePrestador:{
      useNumberGuideRangePrestador: false,
      rangeMin: 1,
      rangeMax: 20,
    },
    insuranceWalletRange:{
      useInsuranceWalletRange: false,
      rangeMin: 1,
      rangeMax: 20,
    },
    passwordRange:{
      usePasswordRange: false,
      rangeMin: 4,
      rangeMax: 20,
    }
  },
  fees:{
    numberGuideRangePrestador:{
      useNumberGuideRangePrestador: false,
      rangeMin: 1,
      rangeMax: 20,
    },
    insuranceWalletRange:{
      useInsuranceWalletRange: false,
      rangeMin: 1,
      rangeMax: 20,
    },
    passwordRange:{
      usePasswordRange: false,
      rangeMin: 4,
      rangeMax: 20,
    }
  },
  appeal: {
    reasonProvider: {
      enable: false,
      rangeMin: 1,
      rangeMax: 20,
    },
    reasonOperator: {
      enable: false,
      rangeMin: 1,
      rangeMax: 20,
    }
  }
};

exports.configPdf = {
  appeal: {
    showName: false,
  },
  guides: {
    useProcedureDateAsGuideEmissionDate: false,
    selectedDateTypeToEmissionGuide: 'dtProcedure',
    guideEmissionDateTypes: [
      {
        value: 'dtProcedure',
        label: 'event.dtProcedure',
      },
      {
        value: 'anesthesiaStart',
        label: 'event.anesthesiaStart',
      }
    ],
    proceduresMaxRowsPerPage: {
      SPSADT: defaultInGuide.proceduresMaxRowsPerPage.SPSADT,
      Consulta: defaultInGuide.proceduresMaxRowsPerPage.Consulta,
      Honorario: defaultInGuide.proceduresMaxRowsPerPage.Honorario
    },
    enableUseHospitalAsExecutor: false,
    useHospitalAsExecutor: [],
    enableProceduresMaxRowsPerPage: false,
    useHospitalAsExecutorTypesEvent: [
      {
        value: status.EventType.Honorario,
        text: 'Honorario',
      },
      {
        value: status.EventType.SPSADT,
        text: 'SP/SADT',
      },
      {
        value: status.EventType.Consulta,
        text: 'Consulta',
      },
    ],
    enableCustomProportionsNamesForGuides: false,
    customProportionsNamesForGuides: {},
    defaultProportionsOnProcedures: [
      {
        name: 'Principal/Única',
        value: 1,
        proportion: 1,
      },
      {
        name: 'Mesma via de acesso',
        value: 2,
        proportion: 0.5,
      },
      {
        name: 'Outra via de acesso',
        value: 3,
        proportion: 0.7,
      }
    ],
    enableCustomTechniqueUsedNamesForGuides: false,
    customTechniqueUsedNamesForGuides: {},
  },
  showEventBarcode: false,
};

exports.defaultProportionsOnProcedures = exports.configPdf.guides.defaultProportionsOnProcedures;

exports.replaceDataBy = {
  numberProviderGuide: [
    {value: 'fillOutWithZero', text: 'Preencher com zero'},
    {value: 'numberProviderGuide', text: 'Número da guia no prestador'},
    {value: 'password', text: 'Senha'},
  ],
  guideNumberSetByOperator: [
    {value: 'fillOutWithZero', text: 'Preencher com zero'},
    {value: 'guideNumberSetByOperator', text: 'Número da guia atribuído pela operadora'},
    {value: 'password', text: 'Senha'},
    {value: 'numberProviderGuide', text: 'Número da guia no prestador'},
  ],
  numberMainGuide: [
    {value: 'fillOutWithZero', text: 'Preencher com zero'},
    {value: 'numberMainGuide', text: 'Número da guia principal'},
    {value: 'password', text: 'Senha'},
    {value: 'numberProviderGuide', text: 'Número da guia no prestador'},
  ],
  solicitationGuideNumberHospitalization: [
    {value: 'fillOutWithZero', text: 'Preencher com zero'},
    {value: 'solicitationGuideNumberHospitalization', text: 'Nº guia de solicitação de internação'},
    {value: 'numberProviderGuide', text: 'Número da guia no prestador'},
    {value: 'password', text: 'Senha'},
  ],
};

exports.replaceDataByQtyZeros = {};

exports.replaceDataByTypeUsingQtyZeros = {};

exports.configHour = {
  defaultHour: {
    hourByAccommodation: {
      [status.Accommodation.APARTMENT]: {
        type: status.GroupPerHourType.VALUE,
        value: 0,
        isAnesthetic: true,
        porteAnestesico: null,
        porte: null,
        proportion: 1,
      },
      [status.Accommodation.NURSERY]: {
        type: status.GroupPerHourType.VALUE,
        value: 0,
        isAnesthetic: true,
        porteAnestesico: null,
        porte: null,
        proportion: 1,
      },
      [status.Accommodation.OUTPATIENT]: {
        type: status.GroupPerHourType.VALUE,
        value: 0,
        isAnesthetic: true,
        porteAnestesico: null,
        porte: null,
        proportion: 1,
      },
      [status.Accommodation.ONE_DAY_CLINIC]: {
        type: status.GroupPerHourType.VALUE,
        value: 0,
        isAnesthetic: true,
        porteAnestesico: null,
        porte: null,
        proportion: 1,
      },
      [status.Accommodation.NONE]: {
        type: status.GroupPerHourType.VALUE,
        value: 0,
        isAnesthetic: true,
        porteAnestesico: null,
        porte: null,
        proportion: 1,
      },
    }
  },
  hours: [],
};

exports.defaultPackage = {
  id: null,
  name: '',
  idProc: '',
  type: status.ProcedureType.KPACKAGE,
  typeValue: status.PackageType.VALUE,
  billingType: status.ProcedureBillingType.BILLABLE,
  value: 0,
  isAnesthetic: true,
  porteAnestesico: null,
  porte: null,
  procedures: [], // Array to store selected procedures
  active: true,
  useAsCBHPM: false,
  config: structuredClone(exports.configHour)
};

exports.defaultHour = {
  type: status.GroupPerHourType.VALUE,
  value: 0,
  isAnesthetic: true,
  porteAnestesico: null,
  porte: null,
  proportion: 1,
};

exports.defaultBillingPerHour = {
  id: null,
  name: '',
  procedures: [], // Array to store selected procedures
  active: true,
  config: structuredClone(exports.configHour),
  billingType: status.ProcedureBillingType.BILLABLE,
};

exports.defaultNegotiation = {
  start: null,
  end: null,
  id: null,
  notTransferOverToProfessional: false,
  enableAttendanceFeeReducingFromProcedure: false,
  overridesProcedures: [],
  customsProcedures: [],
  proceduresToAddCBHPM: [],
  packages: [],
  billingPerHourGroups: [],
  expenses: [],
  customProportionsOnProceduresArray: [],

  ignoreCBHPMIncreases: {
    typesEvent: [],
    techniquesUsed: [],
    // accomodations: [],
  },

  cbhpmId: null,
  useCbhpm: false,
  hasProceduresToAddCBHPM: false,
  proportion: 1,
  portesMap: defaultPortesMap,
  anestheticsProceduresCodes: {},
  anestheticsProceduresCodesByAccommodation: {
    [Accommodation.APARTMENT]: {},
    [Accommodation.NURSERY]: {},
    [Accommodation.OUTPATIENT]: {},
    [Accommodation.ONE_DAY_CLINIC]: {},
    [Accommodation.NONE]: {},
  },
  anestheticsProceduresCodesByEventType: {[EventType.Honorario]: {}, [EventType.SPSADT]: {}, [EventType.Consulta]: {}},
  enableTechniqueUsed: false,
  techniquesUsed: {
    [techniquesUsed.KConventional]: 1,
    [techniquesUsed.KVideo]: 1.5,
    [techniquesUsed.KRobotic]: 2,
  },
  accommodationFactors: {
    [Accommodation.APARTMENT]: 2,
    [Accommodation.NURSERY]: 1,
    [Accommodation.OUTPATIENT]: 1,
    [Accommodation.ONE_DAY_CLINIC]: 1.5,
  },
  accommodationFactorsByEventType: {
    [EventType.Honorario]: {
      [status.Accommodation.APARTMENT]: 2,
      [status.Accommodation.NURSERY]: 1,
      [status.Accommodation.OUTPATIENT]: 1,
      [status.Accommodation.ONE_DAY_CLINIC]: 1.5,
    },
    [EventType.SPSADT]: {
      [status.Accommodation.APARTMENT]: 2,
      [status.Accommodation.NURSERY]: 1,
      [status.Accommodation.OUTPATIENT]: 1,
      [status.Accommodation.ONE_DAY_CLINIC]: 1.5,
    }
  },
  emergencyFactor: 1.3,
  emergencyFactorByEventType: {
    [EventType.Honorario]: 1.3,
    [EventType.Consulta]: 1.3,
    [EventType.SPSADT]: 1.3,
  },
  transfer: {
    taxesIdsApplaying: [],
    additionalTaxesIds: [],
    factorTransfersIds: [],
    factorTransfersInfos: {},
    payer: PayerType.HEALTH_INSURANCE,
    receiver: ReceiverType.SELF,
  },
  uco: {
    SPSADT: {
      enableUCO: false,
      valueUCO: 0,
    },
    Consulta: {
      enableUCO: false,
      valueUCO: 0,
    },
    Honorario: {
      enableUCO: false,
      valueUCO: 0,
    },
  },
  revenueConfigs: exports.revenueConfigs,
  customProportionType: 'FACTOR',
  customProportionTypeByEventType: {
    [EventType.Honorario]: 'FACTOR',
    [EventType.Consulta]: 'FACTOR',
    [EventType.SPSADT]: 'FACTOR',
  },
  accommodationValues: {
    [status.Accommodation.APARTMENT]: 0,
    [status.Accommodation.NURSERY]: 0,
    [status.Accommodation.OUTPATIENT]: 0,
    [status.Accommodation.ONE_DAY_CLINIC]: 0,
  },
  accommodationValuesByEventType: {
    [EventType.Honorario]: {
      [status.Accommodation.APARTMENT]: 0,
      [status.Accommodation.NURSERY]: 0,
      [status.Accommodation.OUTPATIENT]: 0,
      [status.Accommodation.ONE_DAY_CLINIC]: 0,
    },
    [EventType.SPSADT]: {
      [status.Accommodation.APARTMENT]: 0,
      [status.Accommodation.NURSERY]: 0,
      [status.Accommodation.OUTPATIENT]: 0,
      [status.Accommodation.ONE_DAY_CLINIC]: 0,
    }
  },

  emergencyValue: 0,
  emergencyValueByEventType: {
    [EventType.Honorario]: 0,
    [EventType.Consulta]: 0,
    [EventType.SPSADT]: 0,
  },

  isAnesthetisticIndicator: false,
  utm: 1.17,
  anesthetisticIndicators: {},
  enableCustomProportionsByEventType: {
    [EventType.Honorario]: false,
    [EventType.Consulta]: false,
    [EventType.SPSADT]: false,
  }
};

const {
  AnesthetisticIndicatorDefault,
  AnesthetisticIndicatorLeters,
  isPerProcedureTeamEnabled,
} = require('./InsuranceHelpers');

exports.AnesthetisticIndicatorDefault = AnesthetisticIndicatorDefault;
exports.AnesthetisticIndicatorLeters = AnesthetisticIndicatorLeters;
exports.isPerProcedureTeamEnabled = isPerProcedureTeamEnabled;

exports.defaultForm = {
  typesOfPaymentIds: [],
  typesOfPaymentIdsRemovidos: [],
  active: false,
  hasSendGuia: true,
  isParticular: false,
  isNotValued: false,
  hasEvents: true, // Flag para convênio não valorado aparecer ou não no lançamento de eventos
  negotiations: [],
  flags: {
    autoBatchByMonthYear: false,
    enablePerProcedureTeam: false
  },
  fieldsXML: {},
  fieldsXMLByEventType: {
    [EventType.SPSADT]: {},
    [EventType.Consulta]: {},
    [EventType.Honorario]: {},
  },
  fieldsDefaultXML: {},
  fieldsDefaultXMLByEventType: {
    [EventType.SPSADT]: {
      attendimentType: null,
    },
    [EventType.Consulta]: {
      attendimentType: null,
    },
    [EventType.Honorario]: {
      attendimentType: null,
    },
  },
  dataReplaceXML: {
    contratadoSolicitante: '',
    profissionalSolicitante: '',
    localContratado: '',
  },
  dataReplaceXMLByEventType: {
    [EventType.SPSADT]: {
      codigoPrestadorContratadoSolicitante: '',
      codigoPrestadorProfissional: '',
      codigoContratadoExecutante: '',
      codigoLocalContratado: '',
      contratadoSolicitante: '',
      profissionalSolicitante: '',
      localContratado: ''
    },
    [EventType.Consulta]: {
      codigoPrestadorContratadoSolicitante: '',
      codigoPrestadorProfissional: '',
      codigoContratadoExecutante: '',
      codigoLocalContratado: '',
      contratadoSolicitante: '',
      profissionalSolicitante: '',
      localContratado: ''
    },
    [EventType.Honorario]: {
      codigoPrestadorContratadoSolicitante: '',
      codigoPrestadorProfissional: '',
      codigoContratadoExecutante: '',
      codigoLocalContratado: '',
      contratadoSolicitante: '',
      profissionalSolicitante: '',
      localContratado: ''
    },
  },
  configsRange: exports.configsRange,
  configs: {
    numeroGuiaOperadoraPadStart: 7,
    numeroGuiaOirgemPadStartInAppeal: 0,
    autoBatchMaxEvents: 99,
    monthQuantityOnAutoBatchByMonthYear: 1,
    useEventTypeAs: {
      Consulta: null,
      Honorario: null,
      SPSADT: null,
    },
    validateEventAs: {
      Consulta: null,
      Honorario: null,
      SPSADT: null,
    },
    medicalReturn: {
      SPSADT: {
        enable: false,
        setValueZero: true,
        daysMedicalReturn: 0,
      },
      Consulta: {
        enable: false,
        setValueZero: true,
        daysMedicalReturn: 0,
      },
      Honorario: {
        enable: false,
        setValueZero: true,
        daysMedicalReturn: 0,
      },
    },
    configsRange: exports.configsRange,
    factorByAccommodation: {
      NURSERY: {enable: false, elective: 1, emergency: 1},
      APARTMENT: {enable: false, elective: 1, emergency: 1},
      OUTPATIENT: {enable: false, elective: 1, emergency: 1},
      ONE_DAY_CLINIC: {enable: false, elective: 1, emergency: 1},
    },
    replaceDataBy: {},
    replaceDataByTypeUsing: {
      [EventType.SPSADT]: {},
      [EventType.Consulta]: {},
      [EventType.Honorario]: {},
    },
    cooperativeDeadline: {
      enabled: false,
      billingFrequencyDays: 10,
      notifyAfterDays: 5,
    },
    statusDeadline: {
      enabled: false,
      maxDays: 0,
    },
    replaceDataByQtyZeros: {},
    replaceDataByTypeUsingQtyZeros: {
      [EventType.SPSADT]: {},
      [EventType.Consulta]: {},
      [EventType.Honorario]: {},
    },
    selectItemsConsideredToCalculateUnityValue: false,
    itemsConsideredToCalculateUnityValue: {
      accommodation: true,
      isEmergency: true,
      techniqueUsed: true,
      proportion: true,
    },
    showTypePersonInBatch: true,
  },
  configPdf: exports.configPdf,
  rulesOfValues: {},
  customFields: [],
  userCustomDefault: null,
  financial: {
    payer: PayerType.HEALTH_INSURANCE,
  },
  eventFields: {
    create: null,
    check: null,
    xml: null
  },

  sites: [],

  memo: null,
  observationMatriz: null,

  restrictFilial: false,
  companiesAllowed: [],
  logoUrl: null,
  attachments: [],
};
